import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  openIpoModal: false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setOpenIpoModal: (state, action) => {
      state.openIpoModal = action.payload;
    },
  },
});

export const { setOpenIpoModal } = uiSlice.actions;
export default uiSlice.reducer;